import _ from 'lodash';
import { computed, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Component } from 'react';

import styled from 'styled-components';

import { PitstopTable } from 'shared';
import { showDemoVinOrRealVin } from 'shared/utils';
import { CarStore, ShopStore, TableStore, UserStore } from 'stores';

const TableContainer = styled.div`
  display: grid;
  overflow: auto;

  .ant-table {
    max-width: 1600px;
  }
  .ant-table-selection-column {
    width: 50px;
  }

  .ant-table-pagination.ant-pagination {
    text-align: center;
    float: none;
    display: flex;
    justify-content: center;
  }

  .ant-table-filter-column .ant-table-filter-trigger {
    display: none !important;
  }

  @media (max-width: 768px) {
    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td {
      padding: 8px;
    }
  }
`;

class SelectCars extends Component {
  propTypes = {
    rowSelection: PropTypes.object,
  };

  tableStore = new TableStore();

  columns = [
    {
      dataIndex: 'vin',
      filter: true,
      title: 'VIN',
      width: 220,
      render: (vin) => {
        return showDemoVinOrRealVin(vin);
      },
    },
    { dataIndex: 'carName', filter: true, title: 'Unit ID', width: 150 },
    { dataIndex: 'make', filter: true, title: 'Make', width: 150 },
    { dataIndex: 'model', filter: true, title: 'Model', width: 150 },
    { dataIndex: 'year', filter: true, title: 'Year', width: 150 },
    {
      dataIndex: 'userId',
      filter: true,
      title: 'Driver',
      width: 150,
      render: (userId) => {
        let user = UserStore.data.get(userId);

        return (
          <p>
            {user?.firstName} {user?.lastName}
          </p>
        );
      },
    },
  ];

  get data() {
    let data = _.map(this.tableStore?.data, (id) => CarStore.data.get(id));

    return _.filter(data, Boolean);
  }

  render() {
    const { selectedCarIds, onChange, type } = this.props.rowSelection;

    return (
      <TableContainer>
        <PitstopTable
          id={`${ShopStore.currentShop.id} -cars - select - list`}
          tableLayout="fixed"
          data={this.data}
          columns={this.columns}
          fetchData={(filters, table) => {
            const cleanedFilters = { ...filters };

            if (cleanedFilters.filter) {
              Object.keys(cleanedFilters.filter).forEach((key) => {
                if (
                  cleanedFilters.filter[key] === null ||
                  cleanedFilters.filter[key] === undefined ||
                  cleanedFilters.filter[key] === ''
                ) {
                  delete cleanedFilters.filter[key];
                }
              });

              if (Object.keys(cleanedFilters.filter).length === 0) {
                delete cleanedFilters.filter;
              }
            }

            CarStore.getShopCarsForTable(
              cleanedFilters,
              table,
              ShopStore.currentShop.id
            );
          }}
          getTableStore={(tableStore) => (this.tableStore = tableStore)}
          height={400}
          rowSelection={{
            selectedRowKeys: selectedCarIds,
            onChange: onChange,
            hideDefaultSelections: true,
            type,
            selections: [
              {
                key: 'all-data',
                text: 'Select All Data',
                onSelect: (e) => {
                  this.setState({
                    selectedCars: e,
                  });
                },
              },
            ],
          }}
          rowKey="id"
        />
      </TableContainer>
    );
  }
  constructor() {
    super();
    makeObservable(this, {
      tableStore: observable,
      data: computed,
    });
  }
}

export default observer(SelectCars);
